'use strict';

var defineProperty = require('../../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../../Styles/makeStyles.js');
var CircularProgress = require('../../../Feedback/Progress/CircularProgress.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PROGRESS_SIZE_TRANSLATIONS = {
  small: 18,
  medium: 20,
  large: 24
};
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      color: theme.palette.primary.main,
      marginTop: function marginTop(_ref) {
        var size = _ref.size;
        return -(PROGRESS_SIZE_TRANSLATIONS[size] / 2);
      },
      marginLeft: function marginLeft(_ref2) {
        var size = _ref2.size;
        return -(PROGRESS_SIZE_TRANSLATIONS[size] / 2);
      }
    },
    error: {
      color: theme.palette.error.main
    },
    black: {
      color: theme.palette.black.primary
    },
    white: {
      color: theme.palette.white.primary
    }
  };
});

var ButtonCircularProgressV2 = function ButtonCircularProgressV2(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'medium' : _ref3$size,
      color = _ref3.color,
      props = objectWithoutProperties(_ref3, ["size", "color"]);

  var styles = useStyles({
    size: size
  });
  return React__default["default"].createElement(CircularProgress, _objectSpread({}, props, {
    size: PROGRESS_SIZE_TRANSLATIONS[size],
    className: classNames__default["default"](defineProperty({}, styles[color], color !== 'primary'), props.className),
    classes: _objectSpread({
      root: styles.root
    }, props.classes)
  }));
};

module.exports = ButtonCircularProgressV2;
